module.exports = __webpack_public_path__ + "static/media/remove-circle.e960b7ba.svg";